export enum FeatureFlags {
  UPSELL_AB_TEST = "upsell-ab-test",
  COFFEE_LOYALTY = "coffee-loyalty",
  IN_APP_DELIVERY = "in-app-delivery",
  VOUCHERS_PHASE2_ALPHA = "vouchers-phase-2-alpha",
  PROMOS_WALLET_ALPHA = "promos-wallet-alpha",
}
